import { Templates, useTemplate } from "@/util-react/template";
import { MostBoughtDesktopBlackAndBlue } from "@/elements-react/most-bought/templates/most-bought.black-and-blue";
import React from "preact/compat";

const templates: Record<Templates, React.ComponentType | null> = {
  [Templates.DEFAULT]: null,
  [Templates.BLACK_AND_BLUE]: MostBoughtDesktopBlackAndBlue,
};

export const MostBoughtDesktop = () => {
  const template = useTemplate();

  const TemplatedComponent = templates[template.template ?? Templates.DEFAULT];

  return TemplatedComponent ? <TemplatedComponent /> : null;
};
